import a from "./_baseForOwn.js";
import e from "./_createBaseEach.js";
var r = a, o = e, s = o(r), b = s;
export {
  b as default
};
//# sourceMappingURL=_baseEach.js.map
